import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography } from "antd";
import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import StackBarchart from "./chartJs/StackBarchart";

const { Title } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_1 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [dataBar7_1_3, _dataBar7_1_3] = useState();
  const [dataBar7_1_5, _dataBar7_1_5] = useState();
  const [dataBar7_1_9, _dataBar7_1_9] = useState();
  const [dataBar7_1_20, _dataBar7_1_20] = useState();

  const [dataStack7_1_15, _dataStack7_1_15] = useState();
  const [dataStack7_1_16, _dataStack7_1_16] = useState();
  const [dataStack7_1_17, _dataStack7_1_17] = useState();
  const [dataStack7_1_18, _dataStack7_1_18] = useState();

  useEffect(() => {
    Find_barData("bar7_1_3");
    Find_barData("bar7_1_5");
    Find_barData("bar7_1_9");
    Find_barData("bar7_1_20");

    Find_stackData("stack7_1_15");
    Find_stackData("stack7_1_16");
    Find_stackData("stack7_1_17");
    Find_stackData("stack7_1_18");
  }, []);

  const Find_barData = order => {
    axios
      .post(xURL + "db_barchart_db7_1", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = i.name + 543;

            if (order == "bar7_1_3") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "bar7_1_5") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "bar7_1_9") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            } else if (order == "bar7_1_20") {
              Tb1.push({
                name: zyear,
                zcount: i.zcount
              });
            }
          });
        }

        if (order == "bar7_1_3") {
          _dataBar7_1_3(Tb1);
        } else if (order == "bar7_1_5") {
          _dataBar7_1_5(Tb1);
        } else if (order == "bar7_1_9") {
          _dataBar7_1_9(Tb1);
        } else if (order == "bar7_1_20") {
          _dataBar7_1_20(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  const Find_stackData = order => {
    axios
      .post(xURL + "db_stackchart_db7_1", {
        order: order
      })
      .then(result => {
        let Tb1 = [];

        if (result.data) {
          result.data.forEach((i, idx) => {
            let zyear = "";

            zyear = parseInt(i.name) + 543;

            if (order == "stack7_1_15") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "stack7_1_16") {
              Tb1.push({
                name: zyear,
                been: i.been,
                hiv: i.hiv,
                other: i.other
              });
            } else if (order == "stack7_1_17") {
              Tb1.push({
                name: zyear,
                local: i.local,
                nolocal: i.nolocal
              });
            } else if (order == "stack7_1_18") {
              Tb1.push({
                name: zyear,
                local: i.local,
                nolocal: i.nolocal
              });
            }
          });
        }

        if (order == "stack7_1_15") {
          _dataStack7_1_15(Tb1);
        } else if (order == "stack7_1_16") {
          _dataStack7_1_16(Tb1);
        } else if (order == "stack7_1_17") {
          _dataStack7_1_17(Tb1);
        } else if (order == "stack7_1_18") {
          _dataStack7_1_18(Tb1);
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านผลิตภัณฑ์และกระบวนการ
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนการอ้างอิงผลงานวิจัยต่อบทความ (Citation per Publication)"
          >
            <Barchart dataBar={dataBar7_1_3} order={"bar7_1_3"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="ร้อยละของผลงานวิจัยที่ถูกเผยแพร่ใน SCOPUS Q1"
          >
            <Barchart dataBar={dataBar7_1_5} order={"bar7_1_5"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="ร้อยละของ นศ. ที่มีผลงานเผยแพร่ใน SCOPUS Q1(%)"
          >
            <Barchart dataBar={dataBar7_1_9} order={"bar7_1_9"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_15}
              order={"stack7_1_15"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="ร้อยละโครงการวิจัยใหม่ จำแนกตามทิศทางการวิจัย"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_16}
              order={"stack7_1_16"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนโครงการวิจัยใหม่ จำแนกตามแหล่งทุน"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_17}
              order={"stack7_1_17"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="ร้อยละโครงการวิจัยใหม่ จำแนกตามแหล่งทุน"
          >
            <StackBarchart
              dataStackBar={dataStack7_1_18}
              order={"stack7_1_18"}
            />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid #c4dcfdff"
            }}
            title="จำนวนผลงานวิจัยที่ถูกเผยแพร่ใน SCOPUS"
          >
            <Barchart dataBar={dataBar7_1_20} order={"bar7_1_20"} />

            <div
              style={{
                marginTop: 12,
                fontSize: 12,
                color: "#888",
                fontStyle: "italic"
              }}
            >
              หมายเหตุ: ข้อมูลอ้างอิงจากฐานข้อมูล SCOPUS ตามปีปฏิทิน
            </div>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_1;
